import {
  parseListingExpandPlan,
  parserOptionsListingExpand,
  parserOptionsListingFeature
} from "@/utils/parseListingOptions";
import { createSlice } from "@reduxjs/toolkit";

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: {
    featureAddPlanLoading: false,
    error: null,
    featureAddPlan: null,
    expandListPlanLoading: false,
    expandListPlan: null,
    loadingPayment: false,
    checkout_url: null
  },
  reducers: {
    featurePlanRequest: (state) => {
      state.checkout_url = null;
      state.featureAddPlanLoading = true;
    },
    featurePlanSuccess: (state, action) => {
      state.featureAddPlanLoading = false;
      state.featureAddPlan = parserOptionsListingFeature(action.payload);
    },
    featurePlanFailure: (state) => {
      state.featureAddPlanLoading = false;
    },
    expandListPlanRequest: (state) => {
      state.expandListPlanLoading = true;
      state.checkout_url = null;
    },
    expandListPlanSuccess: (state, action) => {
      state.expandListPlanLoading = false;
      state.expandListPlan = parserOptionsListingExpand(action.payload);
      state.plans = parseListingExpandPlan(action.payload);
    },
    expandListPlanFailure: (state) => {
      state.expandListPlanLoading = false;
    },
    subscriptionPaymentRequest: (state) => {
      state.loadingPayment = true;
      state.checkout_url = null;
      state.error = null;
    },
    subscriptionPaymentSuccess: (state, action) => {
      state.loadingPayment = false;
      state.checkout_url = action.payload.checkout_url;
    },
    subscriptionPaymentFailure: (state, action) => {
      state.loadingPayment = false;
      state.error = action.payload.response.data.message;
    },
    reset: (state) => {
      state.error = null;
      state.checkout_url = null;
    }
  }
});

export const {
  featurePlanRequest,
  featurePlanSuccess,
  featurePlanFailure,
  expandListPlanRequest,
  expandListPlanSuccess,
  expandListPlanFailure,
  subscriptionPaymentRequest,
  subscriptionPaymentSuccess,
  subscriptionPaymentFailure,
  reset
} = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
